import styled from 'styled-components'

export default styled.header`
  z-index: 100;
  width: 100%;
  position: sticky;
  background: ${props => props.theme.colors.navbar.background};
  top: 0;
`
